import { url } from "./config";

export var logo: string = '';
export var logoDasboard: string = '';

try {

  let datos = JSON.parse(localStorage.getItem('calidad_user_tag_1'));
  let nombre: string = datos.name;
  if (nombre.localeCompare('Locatec') == 0) {
    logo = url + "upload/logo.jpg";
    logoDasboard = url + "upload/logo.jpg";
  } else if (nombre.localeCompare('FNDB') == 0) {
    logo = url + "upload/logo-fndb.png";
    logoDasboard = url + "upload/logo-fndb.png";
  } else {
    logo = url + "upload/logo.jpg";
    logoDasboard = url + "upload/logo.jpg";
  }


} catch (error) {
  logo = url + "upload/logo.jpg";
  logoDasboard = url + "upload/logo.jpg";
}
//export var logo: string=url+"upload/logo-brio.png";
export var logoLogin: string = url + "upload/logo.jpg";
export var check: string = url + "upload/mark.png";
export var cancel: string = url + "upload/cancel.png";
export var logoLocatec: string = url + "upload/logo.jpg";
